import React, { FC } from 'react';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/system';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
interface IModal {
  children: React.ReactNode;
  title: string;
  renderFooter?: () => React.ReactNode;
  open: boolean;
  onClose?: () => void;
  modalSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ModalForm: FC<IModal> = ({
  children,
  title,
  renderFooter,
  open,
  onClose,
  modalSize = 'sm'
}) => {
  return (
    <div>
      {open && (
        <Dialog open={open} onClose={onClose} maxWidth={modalSize} fullWidth>
          <DialogTitle sx={{ py: 2, pb: 0, px: 4 }}>{title}</DialogTitle>
          <DialogContent sx={{ py: 2, px: 4 }}>
            <Box sx={{ pt: 2 }}>{children}</Box>
            <div className="modal-footer">{renderFooter && renderFooter()}</div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ModalForm;
